import * as React from "react";
import { Input, Label } from "semantic-ui-react";

const ENTER_KEY_CODE = 13;
const DEFAULT_LABEL_PLACEHOLDER = "Click To Edit";

export interface IEditableLabelProps {
  text: string;
  isEditing?: boolean;
  emptyEdit?: boolean;

  labelClassName?: string;
  labelFontSize?: string;
  labelFontWeight?: string;
  labelPlaceHolder?: string;

  inputMaxLength?: number;
  inputPlaceHolder?: string;
  inputTabIndex?: number;
  inputWidth?: string;
  inputHeight?: string;
  inputFontSize?: string;
  inputFontWeight?: string;
  inputClassName?: string;
  inputBorderWidth?: string;

  onFocus?: (value: string) => void;
  onFocusOut?: (value: string) => void;
}

export interface IEditableLabelState {
  isEditing: boolean;
  text: string;
}

export default class EditableLabel extends React.Component<
  IEditableLabelProps,
  IEditableLabelState
> {
  constructor(props: IEditableLabelProps) {
    super(props);

    this.state = {
      isEditing: this.props.isEditing || false,
      text: this.props.text || "",
    };
  }

  public render() {
    if (this.state.isEditing) {
      return (
        <Input
          type="text"
          className={this.props.inputClassName}
          value={this.state.text}
          onChange={this.handleChange}
          onBlur={this.handleFocus}
          onKeyDown={this.handleKeyDown}
          style={{
            width: this.props.inputWidth,
            height: this.props.inputHeight,
            fontSize: this.props.inputFontSize,
            borderWidth: this.props.inputBorderWidth,
          }}
          maxLength={this.props.inputMaxLength}
          placeholder={this.props.inputPlaceHolder}
          tabIndex={this.props.inputTabIndex}
          autoFocus={true}
        />
      );
    }

    return (
      <div>
        <Label className={this.props.labelClassName} onClick={this.handleFocus}>
          {this.isTextValueValid() && this.state.text}
          {!this.isTextValueValid() && (
            <span style={{ fontStyle: "italic" }}>
              {this.props.labelPlaceHolder || DEFAULT_LABEL_PLACEHOLDER}
            </span>
          )}
        </Label>
      </div>
    );
  }

  public componentDidUpdate(prevProps) {
    if (prevProps.text !== this.props.text) {
      this.setState({
        text: this.props.text || "",
      });
    }

    if (prevProps.isEditing !== this.props.isEditing) {
      this.setState({
        isEditing: this.state.isEditing || this.props.isEditing || false,
      });
    }
  }

  isTextValueValid = () => {
    return (
      typeof this.state.text !== "undefined" &&
      this.state.text.trim().length > 0
    );
  };

  handleFocus = () => {
    if (this.state.isEditing) {
      if (typeof this.props.onFocusOut === "function") {
        this.props.onFocusOut(this.state.text);
      }
    } else {
      if (typeof this.props.onFocus === "function") {
        this.props.onFocus(this.state.text);
      }
    }

    if (this.isTextValueValid()) {
      this.setState({
        isEditing: !this.state.isEditing,
      });
    } else {
      if (this.state.isEditing) {
        this.setState({
          isEditing: this.props.emptyEdit || false,
        });
      } else {
        this.setState({
          isEditing: true,
        });
      }
    }
  };

  handleChange = (e, { value }) => {
    this.setState({
      text: value,
    });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === ENTER_KEY_CODE) {
      this.handleEnterKey();
    }
  };

  handleEnterKey = () => {
    this.handleFocus();
  };
}



// WEBPACK FOOTER //
// ./src/components/Filter/widgets/core/EditableLabel.tsx